module.exports = __webpack_public_path__ + "img/open.f2b5002e.png";